export const SET_ROLE = 'SET_ROLE';
export const SET_USER = 'SET_USER';
export const SET_TOKEN = 'SET_TOKEN';
export const ON_LOGOUT = 'ON_LOGOUT';